import {
  PhoneForwardedOutlined,
  PermPhoneMsgOutlined,
  SmsOutlined,
  CellTowerOutlined,
  CreditScoreOutlined,
  ShopOutlined,
  MobileScreenShareOutlined,
  InsertChartOutlined,
  AccountBalanceOutlined,
  PaymentsOutlined,
  BadgeOutlined,
  AssignmentTurnedInOutlined
} from '@mui/icons-material';

import { SERVICE_CATEGORY_TITLE, PAGE_TITLE } from '../../consts';

import { DESCRIPTION } from './descriptions';
import { ProductsCategory } from './interfaces';

const access: ProductsCategory = {
  title: SERVICE_CATEGORY_TITLE.ACCESS,
  products: [
    {
      title: PAGE_TITLE.USSD_SESSION,
      icon: PermPhoneMsgOutlined,
      apiPrivilege: 'USSD',
      description: DESCRIPTION.USSD_SESSION,
      api: {
        guide: 'sdk/ussd',
        doc: 'USSD'
      }
    },
    {
      title: PAGE_TITLE.USSD_PUSH,
      icon: MobileScreenShareOutlined,
      apiPrivilege: 'USSD_PUSH',
      description: DESCRIPTION.USSD_PUSH,
      api: {
        guide: 'sdk/ussd',
        guideSufix: 'new-session-initiated-by-ussd-push',
        doc: 'USSD'
      }
    },
    {
      title: PAGE_TITLE.SMS,
      icon: SmsOutlined,
      apiPrivilege: 'SMS',
      description: DESCRIPTION.SMS,
      api: {
        guide: null,
        doc: 'SMS'
      }
    },
    {
      title: PAGE_TITLE.OPERATOR_LOOKUP,
      icon: CellTowerOutlined,
      apiPrivilege: 'OPERATOR_LOOKUP',
      description: DESCRIPTION.OPERATOR_LOOKUP,
      api: {
        guide: null,
        doc: 'Operator'
      }
    }
  ]
};

const value: ProductsCategory = {
  title: SERVICE_CATEGORY_TITLE.VALUE,
  products: [
    {
      title: PAGE_TITLE.AIRTIME_AND_DATA,
      icon: PhoneForwardedOutlined,
      apiPrivilege: 'AIRTIME_AND_DATA',
      description: DESCRIPTION.AIRTIME_AND_DATA,
      api: {
        guide: 'api/operations/acquire',
        doc: 'Airtime'
      }
    },
    {
      title: PAGE_TITLE.ACCOUNT_TRANSFERS,
      icon: CreditScoreOutlined,
      apiPrivilege: 'TRANSFER',
      description: DESCRIPTION.TRANSFER,
      api: {
        guide: null,
        doc: 'Transfer'
      }
    },
    {
      title: PAGE_TITLE.PAYOUT,
      icon: AccountBalanceOutlined,
      apiPrivilege: 'PAYOUT',
      description: DESCRIPTION.PAYOUT,
      api: {
        guide: 'api/operations/payout',
        doc: 'Payout'
      }
    },
    {
      title: PAGE_TITLE.ONDEMAND,
      icon: ShopOutlined,
      apiPrivilege: 'ON_DEMAND_PAYMENT_AND_ACQUISITION',
      description: DESCRIPTION.ON_DEMAND,
      api: {
        guide: null,
        doc: 'OnDemand'
      }
    },
    {
      title: PAGE_TITLE.MERCHANT_PAYMENT,
      icon: PaymentsOutlined,
      apiPrivilege: 'MERCHANT_PAYMENT',
      description: DESCRIPTION.MERCHANT_PAYMENT,
      api: {
        guide: 'api/operations/merchant-payment',
        doc: 'Merchant payment'
      }
    }
  ]
};

const identity: ProductsCategory = {
  title: SERVICE_CATEGORY_TITLE.IDENTITY,
  products: [
    {
      title: PAGE_TITLE.CUSTOMER_VALIDATION,
      icon: InsertChartOutlined,
      apiPrivilege: 'CUSTOMER_VALIDATION',
      description: DESCRIPTION.CUSTOMER_VALIDATION,
      api: {
        guide: 'api/operations/validate-customer',
        doc: 'Customer validation'
      }
    },
    {
      title: PAGE_TITLE.CUSTOMER_AUTHENTICATION,
      icon: BadgeOutlined,
      apiPrivilege: 'CUSTOMER_AUTHENTICATION',
      description: DESCRIPTION.CUSTOMER_AUTHENTICATION,
      api: {
        guide: 'api/operations/authenticate-customer',
        doc: 'Customer authentication'
      }
    },
    {
      title: PAGE_TITLE.CUSTOMER_ENROLLMENT,
      icon: AssignmentTurnedInOutlined,
      apiPrivilege: 'CUSTOMER_ENROLLMENT',
      description: DESCRIPTION.CUSTOMER_ENROLLMENT,
      api: {
        guide: 'api/operations/enroll-customer',
        doc: 'Customer enrollment'
      }
    }
  ]
};

export const productsAndServicesConfig: ProductsCategory[] = [access, value, identity];
